import { GlobalStore, StoreSafeObject } from '@highlight/ipc'

export const LaunchDarklyRenderer = {
  get: <T extends StoreSafeObject>(key: string, defaultValue: T) => {
    return GlobalStore.flags().get(key, defaultValue)
  },
  all: () => {
    return GlobalStore.flags().all()
  },
  subscribe: <T extends StoreSafeObject>(key: string, callback: (value?: T, previous?: T) => void) => {
    const onUpdate = () => {
      const value = GlobalStore.flags().get<T>(key)
      callback(value, undefined)
    }
    GlobalStore.flags().on(key, callback)
    GlobalStore.flags().on('update', onUpdate)
    return () => {
      GlobalStore.flags().off(key, callback)
      GlobalStore.flags().off('update', onUpdate)
    }
  },
}
